import React, { useState, useEffect } from 'react';

export default function SaveExportModal({ fileName: initialFileName, saveLocation, setSaveLocation, onSave, onCancel, originalFileName, fileOrigin }) {
  const canOverwrite = fileOrigin === 'drive';
  // saveMode: 'overwrite', 'drive-new', 'local'
  const [saveMode, setSaveMode] = useState(
    canOverwrite && saveLocation === 'drive' && initialFileName === originalFileName
      ? 'overwrite'
      : saveLocation === 'drive'
        ? 'drive-new'
        : 'local'
  );
  const [fileName, setFileName] = useState(initialFileName || 'Untitled.svg');

  // Keep saveLocation in sync with saveMode
  useEffect(() => {
    if (saveMode === 'overwrite' || saveMode === 'drive-new') {
      setSaveLocation('drive');
    } else if (saveMode === 'local') {
      setSaveLocation('local');
    }
  }, [saveMode, setSaveLocation]);

  // When switching to overwrite, set fileName to original and disable editing
  useEffect(() => {
    if (saveMode === 'overwrite') {
      setFileName(originalFileName);
    }
  }, [saveMode, originalFileName]);

  const isOverwrite = saveMode === 'overwrite';
  const isDriveNew = saveMode === 'drive-new';
  const isDrive = isOverwrite || isDriveNew;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ fileName, saveLocation, saveMode });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: 420, maxWidth: '95vw' }}>
        <h2>Save / Export</h2>
        <form onSubmit={handleSubmit} className="save-dialog-content">
          <label style={{ fontWeight: 500, marginBottom: 8 }}>File Name</label>
          <input
            type="text"
            value={fileName}
            onChange={e => setFileName(e.target.value)}
            className="save-filename-input"
            autoFocus
            required
            disabled={isOverwrite}
          />
          <div style={{ fontSize: '0.95em', color: '#666', marginTop: 4, marginBottom: 4 }}>
            Source: {fileOrigin === 'drive' ? 'Google Drive' : 'Local'}
          </div>
          <div className="save-location-options">
            {canOverwrite && (
              <label>
                <input
                  type="radio"
                  value="overwrite"
                  checked={saveMode === 'overwrite'}
                  onChange={() => setSaveMode('overwrite')}
                />
                Overwrite original file on Google Drive
              </label>
            )}
            <label>
              <input
                type="radio"
                value="drive-new"
                checked={saveMode === 'drive-new'}
                onChange={() => setSaveMode('drive-new')}
              />
              Save to a new location in Google Drive
            </label>
            <label>
              <input
                type="radio"
                value="local"
                checked={saveMode === 'local'}
                onChange={() => setSaveMode('local')}
              />
              Download to my computer
            </label>
          </div>
          {isDrive ? (
            <>
              {isOverwrite && (
                <div style={{ background: '#fffbe6', border: '1px solid #ffe58f', color: '#ad8b00', borderRadius: 6, padding: '0.5em 1em', marginTop: 8, fontSize: '0.97em' }}>
                  This will overwrite the original file. All changes will be saved to the existing file.
                </div>
              )}
              {isDriveNew && (
                <>
                  <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', color: '#389e0d', borderRadius: 6, padding: '0.5em 1em', marginTop: 8, fontSize: '0.97em' }}>
                    You will be prompted to select a folder where the file should be saved.
                  </div>
                </>
              )}
            </>
          ) : (
            <p style={{ background: '#f6ffed', border: '1px solid #b7eb8f', color: '#389e0d', borderRadius: 6, padding: '0.5em 1em', marginTop: 8, fontSize: '0.97em' }}>
              Depending on your browser settings, you may be prompted to choose a location, or the file may be saved automatically to your default location.
            </p>
          )}
          <div className="modal-actions">
            <button type="button" onClick={onCancel} className="cancel-button">
              Cancel
            </button>
            <button type="submit" className="confirm-button">
              {isOverwrite ? 'Overwrite' : isDriveNew ? 'Save as New' : 'Download'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 